/* eslint-disable */
export default {
  meetingTitle: 'Reunião de {extensionName}',
} as const;

// @key: @#@"meetingTitle"@#@ @source: @#@"{extensionName}'s Meeting"@#@
